//import { PreAuthorisationModel } from 'src/app/core/models/pre-authorisation.model';
import { HttpClient, HttpContext, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, map, Observable, of, tap, throwError, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  EmploymentDetailsModel, JobTitle, LoanDocModel, PreAuthorisationModel, QuoteModel, SearchClientModel,
} from '@lmsModels';

import { CACHE_TTL, CACHING_ENABLED } from '../caching';
import { RETRY_ALLOWED } from '../interceptors/http-error.interceptor';
import { HistoryBean } from '../models/history-models';

@Injectable({
  providedIn: 'root',
})
export class ClientDetailsService {
  userBranch_apiURL = `${environment.apiUrl}/loan/api/user-branch`;
  client_apiURL = `${environment.apiUrl}/loan/api/client`;
  quote_apiURL = `${environment.apiUrl}/loan/api/quote`;
  idNumber: any;
  clientResult: any;
  preAuthorisationModel: PreAuthorisationModel;
  //quoteWorkbook: any;

  accessToken: any;

  httpParams = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
    }),
    context: new HttpContext().set(RETRY_ALLOWED, true)
  };

  constructor(private httpClient: HttpClient) {}

  registerUser(data: any): Observable<any> {
    return this.httpClient
      .post(`${this.userBranch_apiURL}/register`, data, this.httpParams)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  loginCheck(data: any): Observable<any> {
    return this.httpClient
      .post(`${this.userBranch_apiURL}/login_check`, data, this.httpParams)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  userAcccount(data: any) {
    return this.httpClient
      .post(`${this.userBranch_apiURL}/user-acccount`, data,this.httpParams)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  getAllJobTitles() {
    return this.httpClient.get<JobTitle[]>(
      `${this.userBranch_apiURL}/getAllJobTitles`,
    );
  }

  searchUser(data: any): Observable<any | null> {
    return this.httpClient
      .post<any>(`${this.userBranch_apiURL}/searchUser`, data, this.httpParams)
      .pipe(
        catchError(() => of(null)), // Graceful fallback
      );
  }

  resetUserPassword(data: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.userBranch_apiURL}/reset-password`, data, this.httpParams)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  updateUser(data: any) {
    return this.httpClient
      .post<any>(`${this.userBranch_apiURL}/update`, data, this.httpParams)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  validateUserName(username: any) {
    return this.httpClient.post<any>(
      `${this.userBranch_apiURL}/validateuser`,
      username, this.httpParams
    );
    // .pipe(
    //   map((res: any) => {
    //     return res;
    //   })
    // );
  }

  getClientDetails(data: any) {
    return this.httpClient.post<any>(
      `${this.client_apiURL}/search`,
      data,
      this.httpParams
    );
    // .pipe(
    //   map((responseData: any) => {
    //     this.clientResult = responseData;
    //     return responseData;
    //   })
    // );
  }

  // this is same as endpoint call on quotestore service - getClientQuoteDetails
  // getClientQuoteDetails(data: any) {
  //   return this.httpClient
  //     .post<any>(`${this.quote_apiURL}/idNumber`, data)
  //     .pipe(
  //       map((responseData: any) => {
  //         return responseData;
  //       })
  //     )
  // }

  // return this.getClientHistoryRaw(data).subscribe({
  //   next: (responseData) => {
  //     map((responseData: any) => {
  //       this.clientHistoryResult = responseData;
  //       return responseData;
  //     });
  //   },
  // });

  getClientHistoryRaw(data: string) : Observable<any> {
    return this.httpClient.post<any>(`${this.client_apiURL}/history`, data, {
      context: new HttpContext().set(CACHING_ENABLED, false).set(RETRY_ALLOWED, true),
    });
  }

  getClientHistory(data: {
    idNumber: string;
    fromQuoteId: number;
  }): Observable<HistoryBean> {
    return this.httpClient.post<HistoryBean>(
      `${this.client_apiURL}/internalhistory`,
      data,
      {
        context: new HttpContext()
          .set(CACHING_ENABLED, false)
          .set(CACHE_TTL, 60000) // 1 minute
          .set(RETRY_ALLOWED, true),
      },
    );
  }

  applyForAnotherLoan(data: any, requestId?: string) {
    // const headers = requestId
    //   ? {
    //       'X-Debug-Request-Id': requestId,
    //       'Idempotency-Key': requestId,
    //     }
    //   : undefined;
    return this.httpClient
      .post(`${this.client_apiURL}/applyForAnotherLoan`, data, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      })
      .pipe(
        timeout({
          each: 180000,
          with: () => throwError(() => new Error('TimeOut occured')),
        }),
      );
    // .pipe(
    //   map((responseData: any) => {
    //     return responseData;
    //   })
    // );
  }

  getUserBranchStatus(location: {latitude: number, longitude: number, branchSerial: string, consultantId: number}): Observable<any> {
    return this.httpClient.post(`${this.userBranch_apiURL}/userbranchstatus`, location,
      { context: new HttpContext().set(RETRY_ALLOWED, true), responseType: 'text' } );
  }

  getClientByIdNumber(id: string): Observable<SearchClientModel> {
    return this.httpClient.get<SearchClientModel>(environment.apiUrl + id);
  }

  submitClientInformation(data: any) {
    return this.httpClient.post<any>(`${this.client_apiURL}/clientInformation`, data,
      { context: new HttpContext().set(RETRY_ALLOWED, true) },
    );
    // .pipe(
    //   map((responseData: any) => {
    //     return responseData;
    //   })
    // );
  }

  submitAffordability(data: any) {
     return this.httpClient.post<any>(`${this.client_apiURL}/affordability`, data,
      { context: new HttpContext().set(RETRY_ALLOWED, true) },
    );
    // .pipe(
    //   map((responseData: any) => {
    //     return responseData;
    //   })
    // );
  }

  saveChecklist(checklistObject: any) {
    return this.httpClient
      .post<any>(environment.apiUrl + '/document/checklist', checklistObject,
        { context: new HttpContext().set(RETRY_ALLOWED, true) })
      .pipe(
        map((responseData: any) => {
          console.log(responseData);
        }),
      );
  }

  // getFiles(): Observable<any> {
  //   return this.httpClient.get(`${environment.apiUrl}/files`);
  // }

  // uploadDocument(loanDoc: LoanDocModel): Observable<HttpEvent<any>> {
  //   const source$ = this.httpClient
  //     .post<any>(`${this.quote_apiURL}/saveDocument`, loanDoc)
  //     .pipe(tap({
  //       next(responseData) {
  //         return responseData;
  //       }
  //     }));
  //   return source$;
  // }

  uploadDocument(loanDoc: LoanDocModel) {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/saveDocument`, loanDoc, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      });
  }

  uploadDocumentWithProgress(loanDoc: LoanDocModel): Observable<HttpEvent<any>> {
    const req = new HttpRequest('POST', `${this.quote_apiURL}/saveDocument`, loanDoc, {
      reportProgress: true,
      context: new HttpContext().set(RETRY_ALLOWED, true)
    });
    return this.httpClient.request(req);
  }

  download(data: any) {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/viewDocument`, data,this.httpParams)
      .pipe(
        tap((responseData) => {
          console.log(responseData);
        }),
      );
  }

  downloadRaw(data: any) {
    return this.httpClient.post<any>(`${this.quote_apiURL}/viewDocument`, data, {
      context: new HttpContext().set(RETRY_ALLOWED, true) });
  }

  sendSms(data: any) {
    return this.httpClient.post<any>(`${this.client_apiURL}/sms`, data, this.httpParams);
  }

  //   sendSms(data: any) {
  //   return this.httpClient
  //     .post<any>(`${this.client_apiURL}/sms`, data)
  //     .pipe(
  //       map((responseData) => responseData.message), // Extract the message directly
  //       catchError((error) => {
  //         // Handle the error and return an observable with an error message
  //         return of(`Error: ${error.error ? error.error.message : 'An error occurred'}`);
  //       })
  //     );
  // }

  saveEmploymentDetails(data: any) {
    return this.httpClient.post<any>(
      `${this.quote_apiURL}/saveEmployment`,
      data, this.httpParams
    );
    // .pipe(
    //   tap((res: any) => {
    //     return res;
    //   })
    // );
  }

  confirmEmploymentUpdate(data: EmploymentDetailsModel) {
    return this.httpClient.post<any>(
      `${this.quote_apiURL}/confirmEmploymentUpdate`,
      data, this.httpParams
    );
    // .pipe(
    //   tap((res: any) => {
    //     return res;
    //   })
    // );
  }

  findCountries() {
    return this.httpClient.get<any>(`${this.client_apiURL}/countries`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 1 minute
    });
  }

  findProvincies() {
    return this.httpClient.get<any>(`${this.client_apiURL}/provincies`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 1 minute
    });
  }

  findOnboarding() {
    return this.httpClient.get<any>(`${this.client_apiURL}/onboarding`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 10 minute TTL for this request
    });
  }

  findDeliveryChanel() {
    return this.httpClient.get<any>(`${this.client_apiURL}/deliveryChanel`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 1 minute
    });
  }

  findSourceOfFunds() {
    return this.httpClient.get<any>(`${this.client_apiURL}/sourceOfFunds`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 1 minute
    });
  }

  findAll() {
    return this.httpClient.get<any>(`${this.client_apiURL}/findAll`);
  }

  // findCountryScore(natCountry: any) {
  //   return this.httpClient.
  //   get<any>(`${this.client_apiURL}/countryScore/' + natCountry);
  // }

  findEmployment() {
    return this.httpClient.get<any>(`${this.client_apiURL}/employment`);
  }

  findProduct() {
    return this.httpClient.get<any>(`${this.client_apiURL}/product`, {
      context: new HttpContext().set(CACHING_ENABLED, true),
    });
  }

  findCustomer() {
    return this.httpClient.get<any>(`${this.client_apiURL}/customer`, {
      context: new HttpContext().set(CACHING_ENABLED, true),
    });
  }

  findWeighting() {
    return this.httpClient.get<any>(`${this.client_apiURL}/weighting`, {
      context: new HttpContext().set(CACHING_ENABLED, true),
    });
  }

  findNationalCountries() {
    return this.httpClient.get<any>(`${this.client_apiURL}/nationalCountries`, {
      context: new HttpContext().set(CACHING_ENABLED, true),
    });
  }

  findAddressById(id: any): any {
    return this.httpClient.get<any>(`${this.client_apiURL}/getAddress/${id}`);
  }

  listClientDocs(data: any): any {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/listDocuments`, data, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      })
      .pipe(
        tap({
          next(value: any): any {
            return value;
          },
        }),
      );
  }

  listClientDocsByLoanReference(data: LoanDocModel | any): any {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/listDocumentsByLoanReference`, data, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      })
      .pipe(
        tap({
          next(value: any): any {
            return value;
          },
        }),
      );
  }
  getDocChecklist(id: any) {
    return this.httpClient.get<any>(
      `${this.quote_apiURL}/getDocChecklist/${id}`,
    );
  }

  // deleteDocument(id: number): Observable<any> {
  //   return this.httpClient
  //     .delete(environment.apiDocUrl+'/document/api/docs/' + id)
  //    .pipe(
  //     map((responseData: any) => {
  //       return responseData;
  //     })
  //   );
  // }

  deleteDocument(data: any) {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/deleteDoc`, data, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      });
  }

  findLoansToBeApproved() {
    return this.httpClient.get<any>(
      environment.apiUrl + '/loan/approver/loanqueue',
    );
  }

  getCallCentreQuoteDetails(data: any) {
    return this.httpClient
      .post<any>(environment.apiUrl + '/loan/approver/callCentreQuote', data, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      });
  }

  emidBankTransactionsTest(quoteModel: QuoteModel) {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/emidBankTransactions`, quoteModel);
  }

  // checkLexisNexis(data: PreAuthorisationModel) {
  //   return this.httpClient
  //     .post<any>(`${this.client_apiURL}/lexisNexisSearch`, data)
  //     .pipe(
  //       map((responseData: any) => {
  //         return responseData;
  //       })
  //     );
  // }

  findEmploymentByName(data: any) {
    return this.httpClient.post<any>(
      `${this.quote_apiURL}/findEmployment`,
      data,
       { context: new HttpContext().set(RETRY_ALLOWED, true) }
    );
    // .pipe(
    //   map((responseData: any) => {
    //     return responseData;
    //   })
    // );
  }

  sendToCompliance(data: any) {
    return this.httpClient
      .post<any>(`${this.client_apiURL}/sendToCompliance`, data, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      });
  }

  removeScorecard(id: any): Observable<any> {
    return this.httpClient
      .delete(`${this.client_apiURL}/removeScorecard/${id}`);
  }

  getAllRegions() {
    return this.httpClient
      .get<any>(`${this.userBranch_apiURL}/getAllRegions`);
  }

  getAllBranchesByRegion(region: any) {
    return this.httpClient
      .get<any>(`${this.userBranch_apiURL}/getAllBranchesByRegion/${region}`);
  }

  findExistingComplianceData(data: any) {
    return this.httpClient
      .post<any>(`${this.client_apiURL}/fetchExistingComplianceData/`, data, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      });
  }

  validateIdNumber(data: any) {
    return this.httpClient
      .post<any>(`${this.client_apiURL}/validateIdNumber`, data, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      });
  }

  setInterloanStatus(data: any) {
    return this.httpClient
      .post<any>(this.quote_apiURL + '/setInterloanStatus', data, {
        context: new HttpContext().set(RETRY_ALLOWED, true)
      });
  }

  checkClientNameHistory(data: any) {
    return this.httpClient
    .post<any>(`${this.client_apiURL}/name-check`,data, this.httpParams);
}

}
